exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".download-app-container .qr-container img {\n  width: 100px;\n}\n\n/*body{*/\n/*transform: translate(0,0);*/\n/*transition: transform 0.5s;*/\n/*}*/\n/*body.show-download-app-container{*/\n/*transform: translate(0, 132px);*/\n/*}*/", ""]);

// exports
